const STORAGE_KEY = 'wirecraft_recent_imports';
const MAX_RECENT_IMPORTS = 10;

export const getRecentImports = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

export const saveRecentImport = (entry) => {
  const now = new Date().toISOString();
  const current = getRecentImports();
  const key = entry.fileId || entry.driveFileId || `${entry.source || entry.provider}:${entry.name}`;

  const next = [
    { ...entry, importedAt: now },
    ...current.filter(item => (item.fileId || item.driveFileId || `${item.source || item.provider}:${item.name}`) !== key)
  ].slice(0, MAX_RECENT_IMPORTS);

  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
};

export const clearRecentImports = () => {
  localStorage.removeItem(STORAGE_KEY);
};
